import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/red-river': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M353.2 32c52.4 0 94.8 42.4 94.8 94.8v258.4c0 52.4-42.4 94.8-94.8 94.8h-258.4c-52.4 0-94.8-42.4-94.8-94.8v-258.4c0-52.4 42.4-94.8 94.8-94.8h258.4zM144.9 200.9c-0.6-12.4 11.7-24.6 24-24h56.3c27 0 48.9-21.9 48.9-48.9h-154.2c-13.2 0-23.9 10.7-23.9 23.9v154.2c27 0 48.9-21.9 48.9-48.9v-56.3zM321.2 272.9c27 0 48.9-21.9 48.9-48.9h-154.2c-13.2 0-23.9 10.7-23.9 23.9v154.2c27 0 48.9-21.9 48.9-48.9v-56.3c-0.6-12.4 11.7-24.6 24-24h56.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/red-river.js
// module id = 990
// module chunks = 0